import { render, staticRenderFns } from "./tabbar-harta-tidakalih.vue?vue&type=template&id=0f6a1a3d&"
import script from "./tabbar-harta-tidakalih.vue?vue&type=script&lang=js&"
export * from "./tabbar-harta-tidakalih.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports